import {
  BranchOperation,
  ScheduleRuleTemplate,
  Employee,
  VacationRecord,
  HourlyDemandSlot,
  HolidayEvent,
  AuditLogEntry,
  SystemUserAccount,
  SystemNotificationItem,
  OrderHistoryDayCurve,
  OrderHistoryMonthlyStat,
  OrderHistorySlotRecord,
} from "../models/workforce.model";

export const FIREBASE_TOTAL_ORDERS_RECORDS = 9943;
export const FIREBASE_TOTAL_ORDERS_VOLUME = 65608;
export const FIREBASE_TOTAL_OPERATED_DAYS = 243;

export const FIREBASE_SCALE_RULES: ScheduleRuleTemplate[] = [
  {
    "id": "c23f76bb-ec25-4c35-82de-68b9a6084412",
    "nomeRegra": "PADRÃO GERAL",
    "segmentoAlvo": "CTN / GERAL",
    "maxDiasConsecutivos": 6,
    "maxHorasSemIntervalo": 6,
    "intervaloMinHoras": 1,
    "intervaloMaxHoras": 4,
    "descansoInterjornadaHoras": 11,
    "cargaSemanalHoras": 44,
    "cargaComFolgaDomHoras": 36,
    "aberturaCozinhaHoras": 2,
    "aberturaSalaoHoras": 2,
    "fechamentoCozinhaHoras": 2,
    "fechamentoSalaoHoras": 2,
    "liderancaMinimaPresencial": 1,
    "qtdAberturaCozinhaSth": 0,
    "qtdAberturaSalaoSth": 0,
    "qtdAberturaAuxiliarCtnJer": 1,
    "evitarEntradaSaidaPico": true,
    "coberturaOperacionalMinima": 1,
    "domingosFolgaPadraoMes": 1,
    "domingosFolgaMulheresMes": 2
  },
  {
    "id": "089a5569-5481-4c1b-85ea-9c7eb0831aa1",
    "nomeRegra": "PADRÃO STH",
    "segmentoAlvo": "STH",
    "maxDiasConsecutivos": 6,
    "maxHorasSemIntervalo": 6,
    "intervaloMinHoras": 1,
    "intervaloMaxHoras": 4,
    "descansoInterjornadaHoras": 11,
    "cargaSemanalHoras": 44,
    "cargaComFolgaDomHoras": 36,
    "aberturaCozinhaHoras": 2,
    "aberturaSalaoHoras": 2,
    "fechamentoCozinhaHoras": 2,
    "fechamentoSalaoHoras": 2,
    "liderancaMinimaPresencial": 1,
    "qtdAberturaCozinhaSth": 2,
    "qtdAberturaSalaoSth": 2,
    "qtdAberturaAuxiliarCtnJer": 0,
    "evitarEntradaSaidaPico": true,
    "coberturaOperacionalMinima": 1,
    "domingosFolgaPadraoMes": 1,
    "domingosFolgaMulheresMes": 2
  }
];

export const FIREBASE_BRANCHES: BranchOperation[] = [
  {
    "id": "551d774c-444f-4199-b0c4-a63a11dacd6d",
    "codFilial": "H001",
    "codProtheus": "01HBPC0078",
    "nomeFilialBi": "H001",
    "nomeFilialProtheus": "01HBPC0078",
    "cnpj": "13.783.221/0078-40",
    "marca": "MADERO CONTAINER",
    "gmt": "UTC-03:00 (America/Sao_Paulo)",
    "ultimaSincronizacaoBranchOffice": "01/09/2026 18:23",
    "cidade": "BELO HORIZONTE",
    "uf": "MG",
    "pais": "BRASIL",
    "empresaGrupo": "MADERO INDUSTRIA E COMERCIO SA",
    "segmento": "CTN",
    "codDiretor": "DR.05",
    "nomeDiretor": "DIRETOR TESTE 01",
    "codGoOp": "RG.014",
    "nomeGoOp": "GERENTE REGIONAL TESTE 01",
    "horarioGeral": "11:30 - 23:00",
    "regraEscalaId": "c23f76bb-ec25-4c35-82de-68b9a6084412",
    "regraEscalaNome": "PADRÃO GERAL",
    "status": "ATIVA",
    "horariosPorDia": [
      {
        "diaSemana": "DOM",
        "abertura": "11:30",
        "fechamento": "23:00",
        "fechado": false
      },
      {
        "diaSemana": "SEG",
        "abertura": "11:30",
        "fechamento": "23:00",
        "fechado": false
      },
      {
        "diaSemana": "TER",
        "abertura": "11:30",
        "fechamento": "23:00",
        "fechado": false
      },
      {
        "diaSemana": "QUA",
        "abertura": "11:30",
        "fechamento": "23:00",
        "fechado": false
      },
      {
        "diaSemana": "QUI",
        "abertura": "11:30",
        "fechamento": "23:00",
        "fechado": false
      },
      {
        "diaSemana": "SEX",
        "abertura": "11:30",
        "fechamento": "23:00",
        "fechado": false
      },
      {
        "diaSemana": "SAB",
        "abertura": "11:30",
        "fechamento": "23:00",
        "fechado": false
      }
    ],
    "coberturaSemanal": [
      96,
      95,
      97,
      96,
      98,
      95,
      97
    ],
    "escalaPublicada": true,
    "eficienciaMedia": 96.3,
    "quadroAtual": 18,
    "quadroIdeal": 18
  }
];

export const FIREBASE_EMPLOYEES: Employee[] = [
  {
    "id": "df4ad7d5-57c2-4b8f-bc78-6eee469bcc69",
    "chapa": "90001",
    "nome": "COLABORADOR 01",
    "funcao": "GERENTE DE RESTAURANTE",
    "funcaoCod": "GER_RES01",
    "cargoNivel": "LIDERANCA",
    "setor": "Gerência",
    "situacaoReal": "ATIVO",
    "dataAdmissao": "2026-04-02",
    "codFilial": "H001",
    "nomeFilial": "H001 - 01HBPC0078 (BELO HORIZONTE)",
    "regraJornadaId": "75ad77b0-1d11-4ee2-a5ce-aa63594d0667",
    "regraJornadaNome": "6X1 - 07:20 Diárias",
    "domingosTrabalhadosConsecutivos": 0,
    "afastamentos": [
      {
        "id": "afast-1788288378942-xb5jg2",
        "tipo": "LICENCA_MATERNIDADE",
        "dataInicio": "2026-09-27",
        "dataFim": "2026-10-19",
        "motivo": "teste",
        "registradoPor": "Teste teste",
        "registradoEm": "2026-09-01T18:46:18.942Z"
      },
      {
        "id": "afast-1788288118863-rbht7i",
        "tipo": "FERIAS",
        "dataInicio": "2026-09-13",
        "dataFim": "2026-09-26",
        "motivo": "Férias já aceita",
        "registradoPor": "Teste teste",
        "registradoEm": "2026-09-01T18:41:58.863Z"
      }
    ],
    "feriasStart": "2026-09-13",
    "feriasEnd": "2026-09-26"
  },
  {
    "id": "c9a9e8fa-0758-4631-bf83-8eb852959c26",
    "chapa": "90002",
    "nome": "COLABORADOR 02",
    "funcao": "AUXILIAR DE RESTAURANTE",
    "funcaoCod": "AUX_RES01",
    "cargoNivel": "BASE",
    "setor": "Salão",
    "situacaoReal": "ATIVO",
    "dataAdmissao": "2026-05-04",
    "codFilial": "H001",
    "nomeFilial": "H001 - 01HBPC0078 (BELO HORIZONTE)",
    "regraJornadaId": "75ad77b0-1d11-4ee2-a5ce-aa63594d0667",
    "regraJornadaNome": "6X1 - 07:20 Diárias",
    "domingosTrabalhadosConsecutivos": 1,
    "afastamentos": [
      {
        "id": "afast-1788288412521-fg4www",
        "tipo": "LICENCA_PATERNIDADE",
        "dataInicio": "2026-09-06",
        "dataFim": "2026-09-19",
        "motivo": "teste",
        "registradoPor": "Teste teste",
        "registradoEm": "2026-09-01T18:46:52.521Z"
      }
    ]
  },
  {
    "id": "5167d18a-0610-4e34-9b3c-b41959cd7821",
    "chapa": "90003",
    "nome": "COLABORADOR 03",
    "funcao": "COORDENADOR DE RESTAURANTE",
    "funcaoCod": "COOR_RES01",
    "cargoNivel": "LIDERANCA",
    "setor": "Gerência",
    "situacaoReal": "ATIVO",
    "dataAdmissao": "2019-09-25",
    "codFilial": "H001",
    "nomeFilial": "H001 - 01HBPC0078 (BELO HORIZONTE)",
    "regraJornadaId": "75ad77b0-1d11-4ee2-a5ce-aa63594d0667",
    "regraJornadaNome": "6X1 - 07:20 Diárias",
    "domingosTrabalhadosConsecutivos": 2,
    "afastamentos": []
  },
  {
    "id": "60786280-3d0c-4bda-912a-8086fcb3f401",
    "chapa": "90004",
    "nome": "COLABORADOR 04",
    "funcao": "AUXILIAR DE RESTAURANTE",
    "funcaoCod": "AUX_RES01",
    "cargoNivel": "BASE",
    "setor": "Salão",
    "situacaoReal": "ATIVO",
    "dataAdmissao": "2023-05-24",
    "codFilial": "H001",
    "nomeFilial": "H001 - 01HBPC0078 (BELO HORIZONTE)",
    "regraJornadaId": "75ad77b0-1d11-4ee2-a5ce-aa63594d0667",
    "regraJornadaNome": "6X1 - 07:20 Diárias",
    "domingosTrabalhadosConsecutivos": 0,
    "afastamentos": []
  },
  {
    "id": "852b31e7-f008-459a-a4cb-92c95ea99d7c",
    "chapa": "90005",
    "nome": "COLABORADOR 05",
    "funcao": "AUXILIAR DE RESTAURANTE",
    "funcaoCod": "AUX_RES01",
    "cargoNivel": "BASE",
    "setor": "Cozinha",
    "situacaoReal": "ATIVO",
    "dataAdmissao": "2026-05-25",
    "codFilial": "H001",
    "nomeFilial": "H001 - 01HBPC0078 (BELO HORIZONTE)",
    "regraJornadaId": "75ad77b0-1d11-4ee2-a5ce-aa63594d0667",
    "regraJornadaNome": "6X1 - 07:20 Diárias",
    "domingosTrabalhadosConsecutivos": 1,
    "afastamentos": []
  },
  {
    "id": "47cfe26f-4956-4bda-933f-562b4537b788",
    "chapa": "90006",
    "nome": "COLABORADOR 06",
    "funcao": "AUXILIAR DE SERVICOS GERAIS OPER",
    "funcaoCod": "AUX_SG01",
    "cargoNivel": "BASE",
    "setor": "Salão",
    "situacaoReal": "ATIVO",
    "dataAdmissao": "2026-08-13",
    "codFilial": "H001",
    "nomeFilial": "H001 - 01HBPC0078 (BELO HORIZONTE)",
    "regraJornadaId": "75ad77b0-1d11-4ee2-a5ce-aa63594d0667",
    "regraJornadaNome": "6X1 - 07:20 Diárias",
    "domingosTrabalhadosConsecutivos": 2,
    "afastamentos": []
  },
  {
    "id": "63952523-85f6-424e-942f-78ffd446dc1c",
    "chapa": "90007",
    "nome": "COLABORADOR 07",
    "funcao": "AUXILIAR DE RESTAURANTE",
    "funcaoCod": "AUX_RES01",
    "cargoNivel": "BASE",
    "setor": "Cozinha",
    "situacaoReal": "ATIVO",
    "dataAdmissao": "2026-06-01",
    "codFilial": "H001",
    "nomeFilial": "H001 - 01HBPC0078 (BELO HORIZONTE)",
    "regraJornadaId": "75ad77b0-1d11-4ee2-a5ce-aa63594d0667",
    "regraJornadaNome": "6X1 - 07:20 Diárias",
    "domingosTrabalhadosConsecutivos": 0,
    "afastamentos": []
  },
  {
    "id": "7fb8ee62-3cc4-4527-84e7-3d67d45fc289",
    "chapa": "90008",
    "nome": "COLABORADOR 08",
    "funcao": "AUXILIAR DE RESTAURANTE",
    "funcaoCod": "AUX_RES01",
    "cargoNivel": "BASE",
    "setor": "Salão",
    "situacaoReal": "ATIVO",
    "dataAdmissao": "2026-02-02",
    "codFilial": "H001",
    "nomeFilial": "H001 - 01HBPC0078 (BELO HORIZONTE)",
    "regraJornadaId": "75ad77b0-1d11-4ee2-a5ce-aa63594d0667",
    "regraJornadaNome": "6X1 - 07:20 Diárias",
    "domingosTrabalhadosConsecutivos": 1,
    "afastamentos": []
  },
  {
    "id": "3b9296c2-ece7-4e7b-89d5-b520c9e74df6",
    "chapa": "90009",
    "nome": "COLABORADOR 09",
    "funcao": "AUXILIAR DE RESTAURANTE",
    "funcaoCod": "AUX_RES01",
    "cargoNivel": "BASE",
    "setor": "Cozinha",
    "situacaoReal": "ATIVO",
    "dataAdmissao": "2026-03-02",
    "codFilial": "H001",
    "nomeFilial": "H001 - 01HBPC0078 (BELO HORIZONTE)",
    "regraJornadaId": "75ad77b0-1d11-4ee2-a5ce-aa63594d0667",
    "regraJornadaNome": "6X1 - 07:20 Diárias",
    "domingosTrabalhadosConsecutivos": 2,
    "afastamentos": []
  },
  {
    "id": "f2accd6e-1fb5-4ee4-892c-a103ed4c2115",
    "chapa": "90010",
    "nome": "COLABORADOR 10",
    "funcao": "GERENTE DE RESTAURANTE",
    "funcaoCod": "GER_RES01",
    "cargoNivel": "LIDERANCA",
    "setor": "Gerência",
    "situacaoReal": "ATIVO",
    "dataAdmissao": "2021-07-20",
    "codFilial": "H001",
    "nomeFilial": "H001 - 01HBPC0078 (BELO HORIZONTE)",
    "regraJornadaId": "75ad77b0-1d11-4ee2-a5ce-aa63594d0667",
    "regraJornadaNome": "6X1 - 07:20 Diárias",
    "domingosTrabalhadosConsecutivos": 0,
    "afastamentos": []
  },
  {
    "id": "ef3cffb9-38ad-49ad-9f00-47242a777eda",
    "chapa": "90011",
    "nome": "COLABORADOR 11",
    "funcao": "AUXILIAR DE RESTAURANTE",
    "funcaoCod": "AUX_RES01",
    "cargoNivel": "BASE",
    "setor": "Cozinha",
    "situacaoReal": "ATIVO",
    "dataAdmissao": "2026-01-22",
    "codFilial": "H001",
    "nomeFilial": "H001 - 01HBPC0078 (BELO HORIZONTE)",
    "regraJornadaId": "75ad77b0-1d11-4ee2-a5ce-aa63594d0667",
    "regraJornadaNome": "6X1 - 07:20 Diárias",
    "domingosTrabalhadosConsecutivos": 1,
    "afastamentos": []
  },
  {
    "id": "3a3f8a57-9495-454a-9bf6-3bf910729683",
    "chapa": "90012",
    "nome": "COLABORADOR 12",
    "funcao": "AUXILIAR DE RESTAURANTE",
    "funcaoCod": "AUX_RES01",
    "cargoNivel": "BASE",
    "setor": "Salão",
    "situacaoReal": "ATIVO",
    "dataAdmissao": "2026-06-05",
    "codFilial": "H001",
    "nomeFilial": "H001 - 01HBPC0078 (BELO HORIZONTE)",
    "regraJornadaId": "75ad77b0-1d11-4ee2-a5ce-aa63594d0667",
    "regraJornadaNome": "6X1 - 07:20 Diárias",
    "domingosTrabalhadosConsecutivos": 2,
    "afastamentos": []
  },
  {
    "id": "e7c9e623-c3b2-4aea-bd31-8f5ba2c39603",
    "chapa": "90013",
    "nome": "COLABORADOR 13",
    "funcao": "AUXILIAR DE RESTAURANTE",
    "funcaoCod": "AUX_RES01",
    "cargoNivel": "BASE",
    "setor": "Cozinha",
    "situacaoReal": "ATIVO",
    "dataAdmissao": "2026-08-10",
    "codFilial": "H001",
    "nomeFilial": "H001 - 01HBPC0078 (BELO HORIZONTE)",
    "regraJornadaId": "75ad77b0-1d11-4ee2-a5ce-aa63594d0667",
    "regraJornadaNome": "6X1 - 07:20 Diárias",
    "domingosTrabalhadosConsecutivos": 0,
    "afastamentos": []
  },
  {
    "id": "b96d3016-82c6-43f1-8679-17f46477659f",
    "chapa": "90014",
    "nome": "COLABORADOR 14",
    "funcao": "AUXILIAR DE RESTAURANTE",
    "funcaoCod": "AUX_RES01",
    "cargoNivel": "BASE",
    "setor": "Salão",
    "situacaoReal": "ATIVO",
    "dataAdmissao": "2026-02-09",
    "codFilial": "H001",
    "nomeFilial": "H001 - 01HBPC0078 (BELO HORIZONTE)",
    "regraJornadaId": "75ad77b0-1d11-4ee2-a5ce-aa63594d0667",
    "regraJornadaNome": "6X1 - 07:20 Diárias",
    "domingosTrabalhadosConsecutivos": 1,
    "afastamentos": []
  },
  {
    "id": "0e6d9ce6-cef8-4409-9230-8a5e769580db",
    "chapa": "90015",
    "nome": "COLABORADOR 15",
    "funcao": "AUXILIAR DE RESTAURANTE",
    "funcaoCod": "AUX_RES01",
    "cargoNivel": "BASE",
    "setor": "Cozinha",
    "situacaoReal": "ATIVO",
    "dataAdmissao": "2026-05-21",
    "codFilial": "H001",
    "nomeFilial": "H001 - 01HBPC0078 (BELO HORIZONTE)",
    "regraJornadaId": "75ad77b0-1d11-4ee2-a5ce-aa63594d0667",
    "regraJornadaNome": "6X1 - 07:20 Diárias",
    "domingosTrabalhadosConsecutivos": 2,
    "afastamentos": []
  },
  {
    "id": "8d2aabb3-40a1-473a-b209-017a40d4c375",
    "chapa": "90016",
    "nome": "COLABORADOR 16",
    "funcao": "AUXILIAR DE RESTAURANTE",
    "funcaoCod": "AUX_RES01",
    "cargoNivel": "BASE",
    "setor": "Salão",
    "situacaoReal": "ATIVO",
    "dataAdmissao": "2026-06-11",
    "codFilial": "H001",
    "nomeFilial": "H001 - 01HBPC0078 (BELO HORIZONTE)",
    "regraJornadaId": "75ad77b0-1d11-4ee2-a5ce-aa63594d0667",
    "regraJornadaNome": "6X1 - 07:20 Diárias",
    "domingosTrabalhadosConsecutivos": 0,
    "afastamentos": []
  },
  {
    "id": "60ae00aa-5839-45a0-9d7a-a51dbeb93b43",
    "chapa": "90017",
    "nome": "COLABORADOR 17",
    "funcao": "COORDENADOR DE RESTAURANTE",
    "funcaoCod": "COOR_RES01",
    "cargoNivel": "LIDERANCA",
    "setor": "Gerência",
    "situacaoReal": "ATIVO",
    "dataAdmissao": "2021-06-04",
    "codFilial": "H001",
    "nomeFilial": "H001 - 01HBPC0078 (BELO HORIZONTE)",
    "regraJornadaId": "75ad77b0-1d11-4ee2-a5ce-aa63594d0667",
    "regraJornadaNome": "6X1 - 07:20 Diárias",
    "domingosTrabalhadosConsecutivos": 1,
    "afastamentos": []
  },
  {
    "id": "a1b6eaaf-cec9-4a7f-b378-f5d481152977",
    "chapa": "90018",
    "nome": "COLABORADOR 18",
    "funcao": "AUXILIAR DE RESTAURANTE",
    "funcaoCod": "AUX_RES01",
    "cargoNivel": "BASE",
    "setor": "Salão",
    "situacaoReal": "ATIVO",
    "dataAdmissao": "2026-03-23",
    "codFilial": "H001",
    "nomeFilial": "H001 - 01HBPC0078 (BELO HORIZONTE)",
    "regraJornadaId": "75ad77b0-1d11-4ee2-a5ce-aa63594d0667",
    "regraJornadaNome": "6X1 - 07:20 Diárias",
    "domingosTrabalhadosConsecutivos": 2,
    "afastamentos": []
  }
];

export const FIREBASE_VACATIONS: VacationRecord[] = [
  {
    "id": "afast-1788288378942-xb5jg2",
    "chapa": "90001",
    "nomeColaborador": "COLABORADOR 01",
    "funcao": "GERENTE DE RESTAURANTE",
    "codFilial": "H001",
    "nomeFilial": "H001 - 01HBPC0078 (BELO HORIZONTE)",
    "tipo": "LICENCA_MATERNIDADE",
    "dataInicio": "2026-09-27",
    "dataFim": "2026-10-19",
    "diasTotais": 23,
    "origem": "MANUAL",
    "status": "EM_GOZO",
    "motivo": "teste",
    "registradoPor": "Teste teste",
    "registradoEm": "2026-09-01T18:46:18.942Z"
  },
  {
    "id": "afast-1788288118863-rbht7i",
    "chapa": "90001",
    "nomeColaborador": "COLABORADOR 01",
    "funcao": "GERENTE DE RESTAURANTE",
    "codFilial": "H001",
    "nomeFilial": "H001 - 01HBPC0078 (BELO HORIZONTE)",
    "tipo": "FERIAS",
    "dataInicio": "2026-09-13",
    "dataFim": "2026-09-26",
    "diasTotais": 14,
    "origem": "MANUAL",
    "status": "PROGRAMADO",
    "motivo": "Férias já aceita",
    "registradoPor": "Teste teste",
    "registradoEm": "2026-09-01T18:41:58.863Z"
  },
  {
    "id": "afast-1788288412521-fg4www",
    "chapa": "90002",
    "nomeColaborador": "COLABORADOR 02",
    "funcao": "AUXILIAR DE RESTAURANTE",
    "codFilial": "H001",
    "nomeFilial": "H001 - 01HBPC0078 (BELO HORIZONTE)",
    "tipo": "LICENCA_PATERNIDADE",
    "dataInicio": "2026-09-06",
    "dataFim": "2026-09-19",
    "diasTotais": 14,
    "origem": "MANUAL",
    "status": "EM_GOZO",
    "motivo": "teste",
    "registradoPor": "Teste teste",
    "registradoEm": "2026-09-01T18:46:52.521Z"
  }
];

export const FIREBASE_HOLIDAYS: HolidayEvent[] = [
  // ── FERIADOS E DATAS COMERCIAIS DE DATA FIXA (IsRecurring = true / FIXO) ──
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc01',
    data: '2026-01-01',
    nome: 'Confraternização Universal (Ano Novo)',
    escopo: 'NACIONAL',
    ufMunicipio: 'BRASIL (Rede Nacional)',
    fatorImpactoPct: 25,
    impactFactorMultiplier: 1.25,
    recorrenteFixo: true,
    categoriaData: 'FIXO',
    observacao: 'Feriado nacional de data fixa (01/01). Forte movimento de almoço e jantar familiar.'
  },
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc02',
    data: '2026-04-21',
    nome: 'Tiradentes',
    escopo: 'NACIONAL',
    ufMunicipio: 'BRASIL (Rede Nacional)',
    fatorImpactoPct: 20,
    impactFactorMultiplier: 1.2,
    recorrenteFixo: true,
    categoriaData: 'FIXO',
    observacao: 'Feriado nacional de data fixa (21/04).'
  },
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc03',
    data: '2026-05-01',
    nome: 'Dia Mundial do Trabalho',
    escopo: 'NACIONAL',
    ufMunicipio: 'BRASIL (Rede Nacional)',
    fatorImpactoPct: 25,
    impactFactorMultiplier: 1.25,
    recorrenteFixo: true,
    categoriaData: 'FIXO',
    observacao: 'Feriado nacional de data fixa (01/05). Alto fluxo em operações de shopping e container.'
  },
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc04',
    data: '2026-06-12',
    nome: 'Dia dos Namorados (Pico Sazonal Jantar)',
    escopo: 'EVENTO_ESPECIAL',
    ufMunicipio: 'BRASIL (Rede Nacional)',
    fatorImpactoPct: 45,
    impactFactorMultiplier: 1.45,
    recorrenteFixo: true,
    categoriaData: 'FIXO',
    observacao: 'Data comercial fixa (12/06). Maior pico anual de jantar nas operações Steakhouse e Container.'
  },
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc14',
    data: '2026-07-09',
    nome: 'Revolução Constitucionalista de 1932',
    escopo: 'ESTADUAL',
    ufMunicipio: 'SP',
    fatorImpactoPct: 20,
    impactFactorMultiplier: 1.2,
    recorrenteFixo: true,
    categoriaData: 'FIXO',
    observacao: 'Feriado estadual fixo de São Paulo (09/07).'
  },
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc12',
    data: '2026-08-15',
    nome: 'Assunção de Nossa Senhora (Padroeira BH)',
    escopo: 'MUNICIPAL',
    ufMunicipio: 'MG / Belo Horizonte',
    fatorImpactoPct: 20,
    impactFactorMultiplier: 1.2,
    recorrenteFixo: true,
    categoriaData: 'FIXO',
    observacao: 'Feriado municipal fixo de Belo Horizonte (15/08, Filial H001).'
  },
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc1f',
    data: '2026-09-07',
    nome: 'Independência do Brasil',
    escopo: 'NACIONAL',
    ufMunicipio: 'BRASIL (Rede Nacional)',
    fatorImpactoPct: 20,
    impactFactorMultiplier: 1.2,
    recorrenteFixo: true,
    categoriaData: 'FIXO',
    observacao: 'Feriado nacional de data fixa (07/09).'
  },
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc05',
    data: '2026-10-12',
    nome: 'Nossa Senhora Aparecida / Dia das Crianças',
    escopo: 'NACIONAL',
    ufMunicipio: 'BRASIL (Rede Nacional)',
    fatorImpactoPct: 35,
    impactFactorMultiplier: 1.35,
    recorrenteFixo: true,
    categoriaData: 'FIXO',
    observacao: 'Feriado nacional de data fixa (12/10). Forte demanda familiar no almoço e jantar.'
  },
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc06',
    data: '2026-11-02',
    nome: 'Finados',
    escopo: 'NACIONAL',
    ufMunicipio: 'BRASIL (Rede Nacional)',
    fatorImpactoPct: 15,
    impactFactorMultiplier: 1.15,
    recorrenteFixo: true,
    categoriaData: 'FIXO',
    observacao: 'Feriado nacional de data fixa (02/11).'
  },
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc07',
    data: '2026-11-15',
    nome: 'Proclamação da República',
    escopo: 'NACIONAL',
    ufMunicipio: 'BRASIL (Rede Nacional)',
    fatorImpactoPct: 20,
    impactFactorMultiplier: 1.2,
    recorrenteFixo: true,
    categoriaData: 'FIXO',
    observacao: 'Feriado nacional de data fixa (15/11).'
  },
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc08',
    data: '2026-11-20',
    nome: 'Dia Nacional de Zumbi e da Consciência Negra',
    escopo: 'NACIONAL',
    ufMunicipio: 'BRASIL (Rede Nacional)',
    fatorImpactoPct: 20,
    impactFactorMultiplier: 1.2,
    recorrenteFixo: true,
    categoriaData: 'FIXO',
    observacao: 'Feriado nacional de data fixa (20/11, Lei 14.759/2023).'
  },
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc13',
    data: '2026-12-08',
    nome: 'Imaculada Conceição (Feriado Municipal BH)',
    escopo: 'MUNICIPAL',
    ufMunicipio: 'MG / Belo Horizonte',
    fatorImpactoPct: 20,
    impactFactorMultiplier: 1.2,
    recorrenteFixo: true,
    categoriaData: 'FIXO',
    observacao: 'Feriado municipal fixo de Belo Horizonte (08/12, Filial H001).'
  },
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc09',
    data: '2026-12-24',
    nome: 'Véspera de Natal',
    escopo: 'NACIONAL',
    ufMunicipio: 'BRASIL (Rede Nacional)',
    fatorImpactoPct: -15,
    impactFactorMultiplier: 0.85,
    recorrenteFixo: true,
    categoriaData: 'FIXO',
    observacao: 'Data fixa (24/12) com fechamento antecipado de shoppings e retração no turno noturno.'
  },
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc10',
    data: '2026-12-25',
    nome: 'Natal',
    escopo: 'NACIONAL',
    ufMunicipio: 'BRASIL (Rede Nacional)',
    fatorImpactoPct: 15,
    impactFactorMultiplier: 1.15,
    recorrenteFixo: true,
    categoriaData: 'FIXO',
    observacao: 'Feriado nacional de data fixa (25/12).'
  },
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc11',
    data: '2026-12-31',
    nome: 'Véspera de Ano Novo (Réveillon)',
    escopo: 'NACIONAL',
    ufMunicipio: 'BRASIL (Rede Nacional)',
    fatorImpactoPct: -15,
    impactFactorMultiplier: 0.85,
    recorrenteFixo: true,
    categoriaData: 'FIXO',
    observacao: 'Data fixa (31/12) com horário especial de encerramento.'
  },

  // ── FERIADOS E DATAS SAZONAIS MÓVEIS (IsRecurring = false / MOVEL: 2026 e 2027) ──
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc21',
    data: '2026-02-16',
    nome: 'Segunda-feira de Carnaval (2026)',
    escopo: 'NACIONAL',
    ufMunicipio: 'BRASIL (Calendário Móvel 2026)',
    fatorImpactoPct: 20,
    impactFactorMultiplier: 1.2,
    recorrenteFixo: false,
    categoriaData: 'MOVEL',
    observacao: 'Data móvel (48 dias antes da Páscoa).'
  },
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc22',
    data: '2026-02-17',
    nome: 'Terça-feira de Carnaval (2026)',
    escopo: 'NACIONAL',
    ufMunicipio: 'BRASIL (Calendário Móvel 2026)',
    fatorImpactoPct: 25,
    impactFactorMultiplier: 1.25,
    recorrenteFixo: false,
    categoriaData: 'MOVEL',
    observacao: 'Data móvel (47 dias antes da Páscoa).'
  },
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc23',
    data: '2026-02-18',
    nome: 'Quarta-feira de Cinzas (2026)',
    escopo: 'NACIONAL',
    ufMunicipio: 'BRASIL (Calendário Móvel 2026)',
    fatorImpactoPct: 10,
    impactFactorMultiplier: 1.1,
    recorrenteFixo: false,
    categoriaData: 'MOVEL',
    observacao: 'Data móvel (46 dias antes da Páscoa).'
  },
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc24',
    data: '2026-04-03',
    nome: 'Sexta-feira Santa / Paixão de Cristo (2026)',
    escopo: 'NACIONAL',
    ufMunicipio: 'BRASIL (Calendário Móvel 2026)',
    fatorImpactoPct: 25,
    impactFactorMultiplier: 1.25,
    recorrenteFixo: false,
    categoriaData: 'MOVEL',
    observacao: 'Feriado nacional móvel (2 dias antes da Páscoa).'
  },
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc25',
    data: '2026-04-05',
    nome: 'Domingo de Páscoa (2026)',
    escopo: 'NACIONAL',
    ufMunicipio: 'BRASIL (Calendário Móvel 2026)',
    fatorImpactoPct: 35,
    impactFactorMultiplier: 1.35,
    recorrenteFixo: false,
    categoriaData: 'MOVEL',
    observacao: 'Data móvel lunar. Forte pico de almoço familiar nos restaurantes.'
  },
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc26',
    data: '2026-05-10',
    nome: 'Dia das Mães - 2º Dom. de Maio (2026)',
    escopo: 'EVENTO_ESPECIAL',
    ufMunicipio: 'BRASIL (Calendário Móvel 2026)',
    fatorImpactoPct: 50,
    impactFactorMultiplier: 1.5,
    recorrenteFixo: false,
    categoriaData: 'MOVEL',
    observacao: 'Data móvel (2º domingo de maio). Maior pico operacional de almoço do ano na rede Madero.'
  },
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc27',
    data: '2026-06-04',
    nome: 'Corpus Christi (2026)',
    escopo: 'NACIONAL',
    ufMunicipio: 'BRASIL (Calendário Móvel 2026)',
    fatorImpactoPct: 25,
    impactFactorMultiplier: 1.25,
    recorrenteFixo: false,
    categoriaData: 'MOVEL',
    observacao: 'Data móvel (60 dias após o Domingo de Páscoa).'
  },
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc28',
    data: '2026-08-09',
    nome: 'Dia dos Pais - 2º Dom. de Agosto (2026)',
    escopo: 'EVENTO_ESPECIAL',
    ufMunicipio: 'BRASIL (Calendário Móvel 2026)',
    fatorImpactoPct: 45,
    impactFactorMultiplier: 1.45,
    recorrenteFixo: false,
    categoriaData: 'MOVEL',
    observacao: 'Data móvel (2º domingo de agosto). Segundo maior pico de almoço familiar do ano.'
  },
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc29',
    data: '2026-11-27',
    nome: 'Black Friday - 4ª Sexta de Novembro (2026)',
    escopo: 'EVENTO_ESPECIAL',
    ufMunicipio: 'BRASIL (Calendário Móvel 2026)',
    fatorImpactoPct: 35,
    impactFactorMultiplier: 1.35,
    recorrenteFixo: false,
    categoriaData: 'MOVEL',
    observacao: 'Data móvel comercial (4ª sexta-feira de novembro). Alto fluxo em unidades de shopping.'
  },
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc32',
    data: '2027-02-09',
    nome: 'Terça-feira de Carnaval (2027)',
    escopo: 'NACIONAL',
    ufMunicipio: 'BRASIL (Calendário Móvel 2027)',
    fatorImpactoPct: 25,
    impactFactorMultiplier: 1.25,
    recorrenteFixo: false,
    categoriaData: 'MOVEL',
    observacao: 'Data móvel 2027 (47 dias antes da Páscoa de 28/03/2027).'
  },
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc34',
    data: '2027-03-26',
    nome: 'Sexta-feira Santa / Paixão de Cristo (2027)',
    escopo: 'NACIONAL',
    ufMunicipio: 'BRASIL (Calendário Móvel 2027)',
    fatorImpactoPct: 25,
    impactFactorMultiplier: 1.25,
    recorrenteFixo: false,
    categoriaData: 'MOVEL',
    observacao: 'Feriado nacional móvel 2027 (2 dias antes da Páscoa).'
  },
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc35',
    data: '2027-03-28',
    nome: 'Domingo de Páscoa (2027)',
    escopo: 'NACIONAL',
    ufMunicipio: 'BRASIL (Calendário Móvel 2027)',
    fatorImpactoPct: 35,
    impactFactorMultiplier: 1.35,
    recorrenteFixo: false,
    categoriaData: 'MOVEL',
    observacao: 'Data móvel 2027. Forte pico de almoço familiar.'
  },
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc36',
    data: '2027-05-09',
    nome: 'Dia das Mães - 2º Dom. de Maio (2027)',
    escopo: 'EVENTO_ESPECIAL',
    ufMunicipio: 'BRASIL (Calendário Móvel 2027)',
    fatorImpactoPct: 50,
    impactFactorMultiplier: 1.5,
    recorrenteFixo: false,
    categoriaData: 'MOVEL',
    observacao: 'Data móvel 2027 (2º domingo de maio).'
  },
  {
    id: '0ac2d706-8f15-47ce-93b4-948e4229fc37',
    data: '2027-05-27',
    nome: 'Corpus Christi (2027)',
    escopo: 'NACIONAL',
    ufMunicipio: 'BRASIL (Calendário Móvel 2027)',
    fatorImpactoPct: 25,
    impactFactorMultiplier: 1.25,
    recorrenteFixo: false,
    categoriaData: 'MOVEL',
    observacao: 'Data móvel 2027 (60 dias após a Páscoa).'
  }
];

export const FIREBASE_NOTIFICATIONS: SystemNotificationItem[] = [
  {
    "id": "34b0d52f-4d81-447a-9616-8254e1995292",
    "timestamp": "2026-09-01T18:46:52.649Z",
    "type": "Status de Licença Paternidade Registrado",
    "title": "O gestor Teste teste registrou Licença Paternidade para COLABORADOR 02 (06/09/2026 a 19/09/2026). Justificativa: teste",
    "message": "INFO",
    "targetEmployeeId": "ADMIN",
    "targetDate": "H001",
    "ticketId": "c9a9e8fa-0758-4631-bf83-8eb852959c26",
    "readBy": [
      "NFcJvl2fKaNzOiQfH1R9anxQIFf1"
    ]
  },
  {
    "id": "6ab1cc3e-ea6c-438f-aa78-bfce3273cf81",
    "timestamp": "2026-09-01T18:46:19.141Z",
    "type": "Status de Licença Maternidade Registrado",
    "title": "O gestor Teste teste registrou Licença Maternidade para COLABORADOR 01 (27/09/2026 a 19/10/2026). Justificativa: teste",
    "message": "INFO",
    "targetEmployeeId": "ADMIN",
    "targetDate": "H001",
    "ticketId": "df4ad7d5-57c2-4b8f-bc78-6eee469bcc69",
    "readBy": [
      "NFcJvl2fKaNzOiQfH1R9anxQIFf1"
    ]
  },
  {
    "id": "0a66fc47-d7e6-42d0-a98d-4a07659253ad",
    "timestamp": "2026-09-01T18:41:59.071Z",
    "type": "Status de Férias Registrado",
    "title": "O gestor Teste teste registrou Férias para COLABORADOR 01 (13/09/2026 a 26/09/2026). Justificativa: Férias já aceita",
    "message": "INFO",
    "targetEmployeeId": "ADMIN",
    "targetDate": "H001",
    "ticketId": "df4ad7d5-57c2-4b8f-bc78-6eee469bcc69",
    "readBy": [
      "NFcJvl2fKaNzOiQfH1R9anxQIFf1"
    ]
  }
];

export const FIREBASE_SYSTEM_USERS: SystemUserAccount[] = [
  {
    "id": "N2sNVZfL5iRxB5CHJdwTMlpeYT73",
    "nome": "Teste teste",
    "username": "teste.teste",
    "email": "teste.teste@grupomadero.com.br",
    "cargo": "teste",
    "perfil": "Gestor",
    "filiaisVinculadas": [
      "H001"
    ],
    "status": "ATIVO",
    "ultimoAcesso": "01/09/2026 19:01"
  },
  {
    "id": "NFcJvl2fKaNzOiQfH1R9anxQIFf1",
    "nome": "Administrador Madero",
    "username": "adminmadero",
    "email": "adminmadero@grupomadero.com.br",
    "cargo": "Administrador do Sistema",
    "perfil": "Admin",
    "filiaisVinculadas": [
      "TODAS AS OPERAÇÕES",
      "H001"
    ],
    "status": "ATIVO",
    "ultimoAcesso": "01/09/2026 19:01"
  }
];

export const FIREBASE_AUDIT_LOGS: AuditLogEntry[] = [
  {
    "id": "kG6shS9zOrg9KYhjgDFW",
    "timestamp": "01/09/2026 16:01:53",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Escala Administrativa",
    "acao": "CREATE",
    "detalhe": "Publicou uma nova escala de trabalho para a filial \"H001\" (Semana de 06/09 a 12/09/2026) contendo 18 funcionários",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: CREATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "iCF4jcNS7IsDNmVZ3rIf",
    "timestamp": "01/09/2026 16:01:39",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Escala Administrativa",
    "acao": "CREATE",
    "detalhe": "Publicou uma nova escala de trabalho para a filial \"H001\" (Semana de 30/08 a 05/09/2026) contendo 18 funcionários",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: CREATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "CMKkIBOY8PZXDsnzxV6I",
    "timestamp": "01/09/2026 16:01:01",
    "usuarioNome": "Teste teste",
    "usuarioRole": "Gestor",
    "modulo": "Escala Administrativa",
    "acao": "UPDATE",
    "detalhe": "Regerou rascunho de escala para a filial \"H001\" no período de 30/08/2026 a 05/09/2026. Justificativa: teste 2",
    "valorAnterior": "Origem: H001",
    "valorNovo": "Justificativa: teste 2",
    "codFilial": "H001",
    "revertido": false,
    "justificativa": "teste 2"
  },
  {
    "id": "iFTW01GtgoMdrTOpHVjt",
    "timestamp": "01/09/2026 15:59:54",
    "usuarioNome": "Teste teste",
    "usuarioRole": "Gestor",
    "modulo": "Escala Administrativa",
    "acao": "UPDATE",
    "detalhe": "Regerou rascunho de escala para a filial \"H001\" no período de 30/08/2026 a 05/09/2026. Justificativa: teste 2",
    "valorAnterior": "Origem: H001",
    "valorNovo": "Justificativa: teste 2",
    "codFilial": "H001",
    "revertido": false,
    "justificativa": "teste 2"
  },
  {
    "id": "Hbn3FTd3ZMTnlTObizRe",
    "timestamp": "01/09/2026 15:59:47",
    "usuarioNome": "Teste teste",
    "usuarioRole": "Gestor",
    "modulo": "Escala Administrativa",
    "acao": "CREATE",
    "detalhe": "Publicou uma nova escala de trabalho para a filial \"H001\" (Semana de 30/08 a 05/09/2026) contendo 0 funcionários",
    "valorAnterior": "Origem: H001",
    "valorNovo": "Ação: CREATE",
    "codFilial": "H001",
    "revertido": false
  },
  {
    "id": "ZM9YBWTRf47akvVlI9S7",
    "timestamp": "01/09/2026 15:51:58",
    "usuarioNome": "Teste teste",
    "usuarioRole": "Gestor",
    "modulo": "Escala Administrativa",
    "acao": "CREATE",
    "detalhe": "Publicou uma nova escala de trabalho para a filial \"H001\" (Semana de 27/09 a 03/10/2026) contendo 18 funcionários",
    "valorAnterior": "Origem: H001",
    "valorNovo": "Ação: CREATE",
    "codFilial": "H001",
    "revertido": false
  },
  {
    "id": "whEe5z1J2SliSeobRNUW",
    "timestamp": "01/09/2026 15:51:50",
    "usuarioNome": "Teste teste",
    "usuarioRole": "Gestor",
    "modulo": "Escala Administrativa",
    "acao": "CREATE",
    "detalhe": "Publicou uma nova escala de trabalho para a filial \"H001\" (Semana de 20/09 a 26/09/2026) contendo 18 funcionários",
    "valorAnterior": "Origem: H001",
    "valorNovo": "Ação: CREATE",
    "codFilial": "H001",
    "revertido": false
  },
  {
    "id": "58jEkv4JKahftXk5Qm7Q",
    "timestamp": "01/09/2026 15:51:33",
    "usuarioNome": "Teste teste",
    "usuarioRole": "Gestor",
    "modulo": "Escala Administrativa",
    "acao": "CREATE",
    "detalhe": "Publicou uma nova escala de trabalho para a filial \"H001\" (Semana de 13/09 a 19/09/2026) contendo 18 funcionários",
    "valorAnterior": "Origem: H001",
    "valorNovo": "Ação: CREATE",
    "codFilial": "H001",
    "revertido": false
  },
  {
    "id": "2nvEDkObiEpgPmZ9CqC5",
    "timestamp": "01/09/2026 15:49:40",
    "usuarioNome": "Teste teste",
    "usuarioRole": "Gestor",
    "modulo": "Escala Administrativa",
    "acao": "CREATE",
    "detalhe": "Publicou uma nova escala de trabalho para a filial \"H001\" (Semana de 06/09 a 12/09/2026) contendo 18 funcionários",
    "valorAnterior": "Origem: H001",
    "valorNovo": "Ação: CREATE",
    "codFilial": "H001",
    "revertido": false
  },
  {
    "id": "ebXCXsmCOzGRoXnNUbAk",
    "timestamp": "01/09/2026 15:49:35",
    "usuarioNome": "Teste teste",
    "usuarioRole": "Gestor",
    "modulo": "Escala Administrativa",
    "acao": "UPDATE",
    "detalhe": "Regerou rascunho de escala para a filial \"H001\" no período de 06/09/2026 a 12/09/2026. Justificativa: Funcionário de licença",
    "valorAnterior": "Origem: H001",
    "valorNovo": "Justificativa: Funcionário de licença",
    "codFilial": "H001",
    "revertido": false,
    "justificativa": "Funcionário de licença"
  },
  {
    "id": "78xQahvbgMKwLOtUg1PA",
    "timestamp": "01/09/2026 15:46:52",
    "usuarioNome": "Teste teste",
    "usuarioRole": "Gestor",
    "modulo": "Planejamento de Escalas",
    "acao": "CREATE",
    "detalhe": "Registrou status de Licença Paternidade para COLABORADOR 02 (Chapa: 90002) de 06/09/2026 a 19/09/2026. Justificativa: teste",
    "valorAnterior": "Origem: H001",
    "valorNovo": "Ação: CREATE",
    "codFilial": "H001",
    "revertido": false
  },
  {
    "id": "Y42vd3kiWeUTCQOcphlC",
    "timestamp": "01/09/2026 15:46:19",
    "usuarioNome": "Teste teste",
    "usuarioRole": "Gestor",
    "modulo": "Planejamento de Escalas",
    "acao": "CREATE",
    "detalhe": "Registrou status de Licença Maternidade para COLABORADOR 01 (Chapa: 90001) de 27/09/2026 a 19/10/2026. Justificativa: teste",
    "valorAnterior": "Origem: H001",
    "valorNovo": "Ação: CREATE",
    "codFilial": "H001",
    "revertido": false
  },
  {
    "id": "LHSQFQZxZ7aCrNwof60i",
    "timestamp": "01/09/2026 15:43:20",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Feriados/Eventos",
    "acao": "CREATE",
    "detalhe": "Adicionou Independência do Brasil",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: CREATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "jhtN64VTg2Z6mvWHcbAd",
    "timestamp": "01/09/2026 15:41:59",
    "usuarioNome": "Teste teste",
    "usuarioRole": "Gestor",
    "modulo": "Planejamento de Escalas",
    "acao": "CREATE",
    "detalhe": "Registrou status de Férias para COLABORADOR 01 (Chapa: 90001) de 13/09/2026 a 26/09/2026. Justificativa: Férias já aceita",
    "valorAnterior": "Origem: H001",
    "valorNovo": "Ação: CREATE",
    "codFilial": "H001",
    "revertido": false
  },
  {
    "id": "zX3EBm6efO9s4eKHngAY",
    "timestamp": "01/09/2026 15:37:47",
    "usuarioNome": "Teste teste",
    "usuarioRole": "Gestor",
    "modulo": "Escala Administrativa",
    "acao": "CREATE",
    "detalhe": "Publicou uma nova escala de trabalho para a filial \"H001\" (Semana de 06/09 a 12/09/2026) contendo 18 funcionários",
    "valorAnterior": "Origem: H001",
    "valorNovo": "Ação: CREATE",
    "codFilial": "H001",
    "revertido": false
  },
  {
    "id": "qvXjszgWGHX6il2dOXNv",
    "timestamp": "01/09/2026 15:36:56",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Usuários",
    "acao": "UPDATE",
    "detalhe": "Editou dados do usuário Teste teste (Filiais: H001)",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: UPDATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "QxUPhJeNLquND1OfQOir",
    "timestamp": "01/09/2026 15:36:34",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Escala Administrativa",
    "acao": "CREATE",
    "detalhe": "Publicou uma nova escala de trabalho para a filial \"H001\" (Semana de 30/08 a 05/09/2026) contendo 18 funcionários",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: CREATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "im9MVJVWPRUd86Ln0Q3b",
    "timestamp": "01/09/2026 15:35:16",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Funcionários",
    "acao": "UPDATE",
    "detalhe": "Atribuiu em lote a regra combinada 6X1 para 18 funcionários",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: UPDATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "hpLcPjF0ozzFaDYf5awN",
    "timestamp": "01/09/2026 15:28:28",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Regras de Escala",
    "acao": "UPDATE",
    "detalhe": "Editou regra: PADRÃO GERAL",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: UPDATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "MAFPXUTrSnczWC79qKLn",
    "timestamp": "01/09/2026 15:24:53",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Pedidos",
    "acao": "IMPORT",
    "detalhe": "Importou 9943 novos, atualizou 0. Total: 9943 em 1 filiais.",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: IMPORT",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "zJU77ufA0SPwHhQCuRah",
    "timestamp": "01/09/2026 15:24:24",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Funcionários",
    "acao": "UPDATE",
    "detalhe": "Alterou situação para ATIVO de 18 funcionários em lote",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: UPDATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "CykLaHBoI9FGni8BQMtC",
    "timestamp": "01/09/2026 15:24:17",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Funcionários",
    "acao": "IMPORT",
    "detalhe": "Importou planilha: 18 adicionados, 0 atualizados, 0 removidos",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: IMPORT",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "6LHmQvsBuP7PziOyXtyv",
    "timestamp": "01/09/2026 15:24:07",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Regras de Escala",
    "acao": "UPDATE",
    "detalhe": "Editou regra: PADRÃO STH",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: UPDATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "mJ0MdJZVyd3ajfhSP0J1",
    "timestamp": "01/09/2026 15:23:57",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Regras de Escala",
    "acao": "UPDATE",
    "detalhe": "Editou regra: PADRÃO GERAL",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: UPDATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "h7WPiAcLm9y2f6esd7VE",
    "timestamp": "01/09/2026 15:23:31",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Filiais",
    "acao": "CREATE",
    "detalhe": "Criou filial: H001",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: CREATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "oETDOa7W3HkvQi1uiSoG",
    "timestamp": "01/09/2026 15:21:49",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Filiais",
    "acao": "DELETE_ALL",
    "detalhe": "Excluiu TODAS as filiais (283)",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: DELETE_ALL",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "iJi3CMu27ZeuzteBZ51B",
    "timestamp": "01/09/2026 15:21:45",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Funcionários",
    "acao": "DELETE_ALL",
    "detalhe": "Excluiu TODOS os funcionários (6099)",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: DELETE_ALL",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "Z9y7lY4boBV2PXUltVi6",
    "timestamp": "01/09/2026 15:21:35",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Pedidos",
    "acao": "DELETE_ALL",
    "detalhe": "Excluiu TODOS os registros de pedidos (365104)",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: DELETE_ALL",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "zDvmP3xppxusl9dLDpyu",
    "timestamp": "01/09/2026 13:28:02",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Usuários",
    "acao": "CREATE",
    "detalhe": "Criou novo usuário Teste teste",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: CREATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "Rbv7nIsthUxbAExkFnNt",
    "timestamp": "01/09/2026 13:26:39",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Pedidos",
    "acao": "IMPORT",
    "detalhe": "Importou 365104 novos, atualizou 0. Total: 365104 em 285 filiais.",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: IMPORT",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "QdOmAvuqoa1xKEoPwXbT",
    "timestamp": "01/09/2026 13:25:29",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Pedidos",
    "acao": "DELETE_ALL",
    "detalhe": "Excluiu TODOS os registros de pedidos (1000)",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: DELETE_ALL",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "1LSLNJl2MnAldSo5mwpG",
    "timestamp": "01/09/2026 13:07:16",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Filiais",
    "acao": "UPDATE",
    "detalhe": "Editou filial: 363",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: UPDATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "Tz7j77j78EyiefYJe0ne",
    "timestamp": "01/09/2026 13:06:33",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Filiais",
    "acao": "UPDATE",
    "detalhe": "Editou filial: H012",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: UPDATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "xbys3GixbT0h5LAiLCaB",
    "timestamp": "01/09/2026 13:04:09",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Regras de Escala",
    "acao": "UPDATE",
    "detalhe": "Editou regra: PADRÃO STH",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: UPDATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "SqwTYweATwaDas2E3o1v",
    "timestamp": "01/09/2026 13:04:03",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Regras de Escala",
    "acao": "UPDATE",
    "detalhe": "Editou regra: PADRÃO STH",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: UPDATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "EAGrDlzSTe71yYQnWjnY",
    "timestamp": "01/09/2026 13:03:38",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Regras de Escala",
    "acao": "CREATE",
    "detalhe": "Criou regra: PADRÃO STH",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: CREATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "rE6GlcjuAHAsDF8LrGXW",
    "timestamp": "01/09/2026 13:03:13",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Regras de Escala",
    "acao": "CREATE",
    "detalhe": "Criou regra: PADRÃO GERAL",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: CREATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "OHg6IoOoad0xazIAZQpV",
    "timestamp": "01/09/2026 13:02:33",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Pedidos",
    "acao": "IMPORT",
    "detalhe": "Importou 365104 novos. Arquivos particionados salvos em Parquet.",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: IMPORT",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "tQib4NXmjWUI1i9BW2cf",
    "timestamp": "01/09/2026 12:59:17",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Funções (Mapeamento)",
    "acao": "UPDATE",
    "detalhe": "Editou parametrização de função para: GERENTE DE EMPORIO",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: UPDATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "vWN7tYRZKNRYhtzNRQcV",
    "timestamp": "01/09/2026 12:59:12",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Funções (Mapeamento)",
    "acao": "UPDATE",
    "detalhe": "Editou parametrização de função para: COORDENADOR DE EMPORIO",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: UPDATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "cCofjyXFW0H75Cv6mqCa",
    "timestamp": "01/09/2026 12:59:06",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Funções (Mapeamento)",
    "acao": "UPDATE",
    "detalhe": "Editou parametrização de função para: COORDENADOR DE SALAO E DELIVERY",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: UPDATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "Wuf1XCOHBzQUUlJkuomD",
    "timestamp": "01/09/2026 12:58:59",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Funções (Mapeamento)",
    "acao": "UPDATE",
    "detalhe": "Editou parametrização de função para: GERENTE DE SALAO",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: UPDATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "oUu6g3sK3qXl68ZUwkIK",
    "timestamp": "01/09/2026 12:58:54",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Funções (Mapeamento)",
    "acao": "UPDATE",
    "detalhe": "Editou parametrização de função para: COORDENADOR DE SALAO",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: UPDATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "i0lo9hw1EJ0Ku1exbKUx",
    "timestamp": "01/09/2026 12:58:49",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Funções (Mapeamento)",
    "acao": "UPDATE",
    "detalhe": "Editou parametrização de função para: GERENTE DE COZINHA",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: UPDATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "nIXjFRKdwlBoCiqNwkPY",
    "timestamp": "01/09/2026 12:58:44",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Funções (Mapeamento)",
    "acao": "UPDATE",
    "detalhe": "Editou parametrização de função para: COORDENADOR DE COZINHA",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: UPDATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "i94wLDcNn4mwxYMooesa",
    "timestamp": "01/09/2026 12:58:38",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Funções (Mapeamento)",
    "acao": "UPDATE",
    "detalhe": "Editou parametrização de função para: COORDENADOR DE RESTAURANTE E DELIVERY",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: UPDATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "JT7QPVNGfGZH02FK6sE9",
    "timestamp": "01/09/2026 12:58:33",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Funções (Mapeamento)",
    "acao": "UPDATE",
    "detalhe": "Editou parametrização de função para: COORDENADOR DE RESTAURANTE",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: UPDATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "RjEarUUZ2kIJHyHvTVeJ",
    "timestamp": "01/09/2026 12:58:28",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Funções (Mapeamento)",
    "acao": "UPDATE",
    "detalhe": "Editou parametrização de função para: GERENTE DE RESTAURANTE",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: UPDATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "6rxZNECgJ4NHby8bcjU2",
    "timestamp": "01/09/2026 12:58:21",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Funcionários",
    "acao": "UPDATE",
    "detalhe": "Alterou situação para ATIVO de 6099 funcionários em lote",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: UPDATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "BagkM5736IQNoEd0yZvx",
    "timestamp": "01/09/2026 12:58:10",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Funcionários",
    "acao": "IMPORT",
    "detalhe": "Importou planilha: 6099 adicionados, 0 atualizados, 0 removidos",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: IMPORT",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "Yxm2OpQKlIE5ODNRdSqG",
    "timestamp": "01/09/2026 12:57:37",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Funcionários",
    "acao": "DELETE_ALL",
    "detalhe": "Excluiu TODOS os funcionários (6131)",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: DELETE_ALL",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "n4F354e7QI3NheChJVT1",
    "timestamp": "01/09/2026 12:42:00",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Funcionários",
    "acao": "IMPORT",
    "detalhe": "Importou planilha: 6131 adicionados, 0 atualizados, 0 removidos",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: IMPORT",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "c4Gu97UeU4y7HECcYyJ1",
    "timestamp": "01/09/2026 12:36:38",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Escalas (Mapeamento)",
    "acao": "UPDATE",
    "detalhe": "Editou regra combinada de escala e jornada: 6X1",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: UPDATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "mlG50GpQ2XFjeYwgwQv3",
    "timestamp": "01/09/2026 12:36:13",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Funcionários",
    "acao": "DELETE_ALL",
    "detalhe": "Excluiu TODOS os funcionários (6131)",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: DELETE_ALL",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "mRROfuzsDmdMm3MwjDe1",
    "timestamp": "01/09/2026 12:34:25",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Funcionários",
    "acao": "IMPORT",
    "detalhe": "Importou planilha: 6131 adicionados, 0 atualizados, 0 removidos",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: IMPORT",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "PPBtzZ9guLW1O5XtMG3j",
    "timestamp": "01/09/2026 12:33:58",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Funcionários",
    "acao": "DELETE_ALL",
    "detalhe": "Excluiu TODOS os funcionários (6131)",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: DELETE_ALL",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "MH9XHajz14aTKlYdqvno",
    "timestamp": "01/09/2026 12:21:47",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Funcionários",
    "acao": "IMPORT",
    "detalhe": "Importou planilha: 6131 adicionados, 0 atualizados, 0 removidos",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: IMPORT",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "2ykNbtZAvRm7J7na0jPB",
    "timestamp": "01/09/2026 12:21:07",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Filiais",
    "acao": "CREATE",
    "detalhe": "Criou filial: J035",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: CREATE",
    "codFilial": "Matriz",
    "revertido": false
  },
  {
    "id": "DPASXo8Z1BsFcjt6O2as",
    "timestamp": "01/09/2026 11:24:38",
    "usuarioNome": "Administrador Madero",
    "usuarioRole": "Admin",
    "modulo": "Filiais",
    "acao": "IMPORT",
    "detalhe": "Importou lista com 282 novas e 0 atualizadas",
    "valorAnterior": "Origem: Matriz",
    "valorNovo": "Ação: IMPORT",
    "codFilial": "Matriz",
    "revertido": false
  }
];

export const FIREBASE_HOURLY_DEMAND: HourlyDemandSlot[] = [
  {
    "hora": "09:00",
    "pedidosPrevistos": 0,
    "staffCozinhaEscalado": 2,
    "staffSalaoEscalado": 2,
    "staffTotalEscalado": 4,
    "staffIdeal": 4,
    "isPico": false
  },
  {
    "hora": "10:00",
    "pedidosPrevistos": 2,
    "staffCozinhaEscalado": 2,
    "staffSalaoEscalado": 2,
    "staffTotalEscalado": 4,
    "staffIdeal": 4,
    "isPico": false
  },
  {
    "hora": "11:00",
    "pedidosPrevistos": 7,
    "staffCozinhaEscalado": 3,
    "staffSalaoEscalado": 3,
    "staffTotalEscalado": 6,
    "staffIdeal": 6,
    "isPico": false
  },
  {
    "hora": "12:00",
    "pedidosPrevistos": 38,
    "staffCozinhaEscalado": 5,
    "staffSalaoEscalado": 6,
    "staffTotalEscalado": 11,
    "staffIdeal": 11,
    "isPico": true
  },
  {
    "hora": "13:00",
    "pedidosPrevistos": 21,
    "staffCozinhaEscalado": 4,
    "staffSalaoEscalado": 5,
    "staffTotalEscalado": 9,
    "staffIdeal": 9,
    "isPico": false
  },
  {
    "hora": "14:00",
    "pedidosPrevistos": 11,
    "staffCozinhaEscalado": 3,
    "staffSalaoEscalado": 4,
    "staffTotalEscalado": 7,
    "staffIdeal": 7,
    "isPico": false
  },
  {
    "hora": "15:00",
    "pedidosPrevistos": 9,
    "staffCozinhaEscalado": 3,
    "staffSalaoEscalado": 3,
    "staffTotalEscalado": 6,
    "staffIdeal": 6,
    "isPico": false
  },
  {
    "hora": "16:00",
    "pedidosPrevistos": 6,
    "staffCozinhaEscalado": 3,
    "staffSalaoEscalado": 3,
    "staffTotalEscalado": 6,
    "staffIdeal": 6,
    "isPico": false
  },
  {
    "hora": "17:00",
    "pedidosPrevistos": 17,
    "staffCozinhaEscalado": 4,
    "staffSalaoEscalado": 4,
    "staffTotalEscalado": 8,
    "staffIdeal": 8,
    "isPico": false
  },
  {
    "hora": "18:00",
    "pedidosPrevistos": 31,
    "staffCozinhaEscalado": 5,
    "staffSalaoEscalado": 5,
    "staffTotalEscalado": 10,
    "staffIdeal": 10,
    "isPico": false
  },
  {
    "hora": "19:00",
    "pedidosPrevistos": 52,
    "staffCozinhaEscalado": 6,
    "staffSalaoEscalado": 7,
    "staffTotalEscalado": 13,
    "staffIdeal": 13,
    "isPico": true
  },
  {
    "hora": "20:00",
    "pedidosPrevistos": 58,
    "staffCozinhaEscalado": 7,
    "staffSalaoEscalado": 7,
    "staffTotalEscalado": 14,
    "staffIdeal": 14,
    "isPico": true
  },
  {
    "hora": "21:00",
    "pedidosPrevistos": 48,
    "staffCozinhaEscalado": 6,
    "staffSalaoEscalado": 6,
    "staffTotalEscalado": 12,
    "staffIdeal": 12,
    "isPico": true
  },
  {
    "hora": "22:00",
    "pedidosPrevistos": 50,
    "staffCozinhaEscalado": 6,
    "staffSalaoEscalado": 6,
    "staffTotalEscalado": 12,
    "staffIdeal": 12,
    "isPico": true
  },
  {
    "hora": "23:00",
    "pedidosPrevistos": 17,
    "staffCozinhaEscalado": 4,
    "staffSalaoEscalado": 4,
    "staffTotalEscalado": 8,
    "staffIdeal": 8,
    "isPico": false
  }
];

export const FIREBASE_DAY_CURVES: OrderHistoryDayCurve[] = [
  {
    "diaSemana": "Segunda-feira",
    "sigla": "SEG",
    "diasAmostrados": 35,
    "totalPedidos": 6027,
    "mediaDiariaPedidos": 172,
    "porHora": {
      "11:00": 2,
      "12:00": 14,
      "13:00": 8,
      "14:00": 4,
      "15:00": 6,
      "16:00": 5,
      "17:00": 6,
      "18:00": 13,
      "19:00": 28,
      "20:00": 30,
      "21:00": 27,
      "22:00": 19,
      "23:00": 4
    }
  },
  {
    "diaSemana": "Terça-feira",
    "sigla": "TER",
    "diasAmostrados": 34,
    "totalPedidos": 6536,
    "mediaDiariaPedidos": 192,
    "porHora": {
      "11:00": 4,
      "12:00": 19,
      "13:00": 10,
      "14:00": 6,
      "15:00": 8,
      "16:00": 5,
      "17:00": 8,
      "18:00": 17,
      "19:00": 27,
      "20:00": 31,
      "21:00": 23,
      "22:00": 20,
      "23:00": 9
    }
  },
  {
    "diaSemana": "Quarta-feira",
    "sigla": "QUA",
    "diasAmostrados": 34,
    "totalPedidos": 6891,
    "mediaDiariaPedidos": 203,
    "porHora": {
      "11:00": 6,
      "12:00": 21,
      "13:00": 11,
      "14:00": 7,
      "15:00": 7,
      "16:00": 6,
      "17:00": 7,
      "18:00": 14,
      "19:00": 37,
      "20:00": 31,
      "21:00": 25,
      "22:00": 25,
      "23:00": 3
    }
  },
  {
    "diaSemana": "Quinta-feira",
    "sigla": "QUI",
    "diasAmostrados": 35,
    "totalPedidos": 8370,
    "mediaDiariaPedidos": 239,
    "porHora": {
      "11:00": 6,
      "12:00": 25,
      "13:00": 13,
      "14:00": 7,
      "15:00": 6,
      "16:00": 5,
      "17:00": 9,
      "18:00": 20,
      "19:00": 38,
      "20:00": 37,
      "21:00": 40,
      "22:00": 25,
      "23:00": 7
    }
  },
  {
    "diaSemana": "Sexta-feira",
    "sigla": "SEX",
    "diasAmostrados": 35,
    "totalPedidos": 12772,
    "mediaDiariaPedidos": 365,
    "porHora": {
      "11:00": 7,
      "12:00": 38,
      "13:00": 21,
      "14:00": 11,
      "15:00": 9,
      "16:00": 6,
      "17:00": 17,
      "18:00": 31,
      "19:00": 52,
      "20:00": 58,
      "21:00": 48,
      "22:00": 50,
      "23:00": 17
    }
  },
  {
    "diaSemana": "Sábado",
    "sigla": "SÁB",
    "diasAmostrados": 35,
    "totalPedidos": 12299,
    "mediaDiariaPedidos": 351,
    "porHora": {
      "11:00": 3,
      "12:00": 13,
      "13:00": 18,
      "14:00": 14,
      "15:00": 14,
      "16:00": 10,
      "17:00": 11,
      "18:00": 20,
      "19:00": 46,
      "20:00": 52,
      "21:00": 54,
      "22:00": 64,
      "23:00": 25
    }
  },
  {
    "diaSemana": "Domingo",
    "sigla": "DOM",
    "diasAmostrados": 35,
    "totalPedidos": 12713,
    "mediaDiariaPedidos": 363,
    "porHora": {
      "11:00": 2,
      "12:00": 11,
      "13:00": 16,
      "14:00": 14,
      "15:00": 17,
      "16:00": 16,
      "17:00": 12,
      "18:00": 21,
      "19:00": 38,
      "20:00": 53,
      "21:00": 51,
      "22:00": 75,
      "23:00": 23
    }
  }
];

export const FIREBASE_MONTHLY_STATS: OrderHistoryMonthlyStat[] = [
  {
    "mes": "jan",
    "mesLabel": "Janeiro/2026",
    "ano": "2026",
    "codFilial": "H001",
    "registros15Min": 1257,
    "diasOperados": 31,
    "totalPedidos": 7525,
    "mediaPedidosDia": 243
  },
  {
    "mes": "fev",
    "mesLabel": "Fevereiro/2026",
    "ano": "2026",
    "codFilial": "H001",
    "registros15Min": 1133,
    "diasOperados": 28,
    "totalPedidos": 7825,
    "mediaPedidosDia": 279
  },
  {
    "mes": "mar",
    "mesLabel": "Março/2026",
    "ano": "2026",
    "codFilial": "H001",
    "registros15Min": 1263,
    "diasOperados": 31,
    "totalPedidos": 8387,
    "mediaPedidosDia": 271
  },
  {
    "mes": "abr",
    "mesLabel": "Abril/2026",
    "ano": "2026",
    "codFilial": "H001",
    "registros15Min": 1260,
    "diasOperados": 30,
    "totalPedidos": 8263,
    "mediaPedidosDia": 275
  },
  {
    "mes": "mai",
    "mesLabel": "Maio/2026",
    "ano": "2026",
    "codFilial": "H001",
    "registros15Min": 1262,
    "diasOperados": 31,
    "totalPedidos": 9203,
    "mediaPedidosDia": 297
  },
  {
    "mes": "jun",
    "mesLabel": "Junho/2026",
    "ano": "2026",
    "codFilial": "H001",
    "registros15Min": 1215,
    "diasOperados": 30,
    "totalPedidos": 7643,
    "mediaPedidosDia": 255
  },
  {
    "mes": "jul",
    "mesLabel": "Julho/2026",
    "ano": "2026",
    "codFilial": "H001",
    "registros15Min": 1275,
    "diasOperados": 31,
    "totalPedidos": 8060,
    "mediaPedidosDia": 260
  },
  {
    "mes": "ago",
    "mesLabel": "Agosto/2026",
    "ano": "2026",
    "codFilial": "H001",
    "registros15Min": 1278,
    "diasOperados": 31,
    "totalPedidos": 8702,
    "mediaPedidosDia": 281
  }
];

export const FIREBASE_RECENT_ORDER_SLOTS: OrderHistorySlotRecord[] = [
  {
    "id": "H001_2026_ago_30_23:00",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "23:00",
    "qtdPedidos": 1
  },
  {
    "id": "H001_2026_ago_30_22:45",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "22:45",
    "qtdPedidos": 8
  },
  {
    "id": "H001_2026_ago_30_22:30",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "22:30",
    "qtdPedidos": 10
  },
  {
    "id": "H001_2026_ago_30_22:15",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "22:15",
    "qtdPedidos": 2
  },
  {
    "id": "H001_2026_ago_30_22:00",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "22:00",
    "qtdPedidos": 6
  },
  {
    "id": "H001_2026_ago_30_21:45",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "21:45",
    "qtdPedidos": 17
  },
  {
    "id": "H001_2026_ago_30_21:30",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "21:30",
    "qtdPedidos": 56
  },
  {
    "id": "H001_2026_ago_30_21:15",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "21:15",
    "qtdPedidos": 30
  },
  {
    "id": "H001_2026_ago_30_21:00",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "21:00",
    "qtdPedidos": 29
  },
  {
    "id": "H001_2026_ago_30_20:45",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "20:45",
    "qtdPedidos": 16
  },
  {
    "id": "H001_2026_ago_30_20:30",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "20:30",
    "qtdPedidos": 12
  },
  {
    "id": "H001_2026_ago_30_20:15",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "20:15",
    "qtdPedidos": 7
  },
  {
    "id": "H001_2026_ago_30_20:00",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "20:00",
    "qtdPedidos": 8
  },
  {
    "id": "H001_2026_ago_30_19:45",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "19:45",
    "qtdPedidos": 1
  },
  {
    "id": "H001_2026_ago_30_19:30",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "19:30",
    "qtdPedidos": 11
  },
  {
    "id": "H001_2026_ago_30_19:15",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "19:15",
    "qtdPedidos": 11
  },
  {
    "id": "H001_2026_ago_30_19:00",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "19:00",
    "qtdPedidos": 11
  },
  {
    "id": "H001_2026_ago_30_18:45",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "18:45",
    "qtdPedidos": 10
  },
  {
    "id": "H001_2026_ago_30_18:30",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "18:30",
    "qtdPedidos": 8
  },
  {
    "id": "H001_2026_ago_30_18:15",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "18:15",
    "qtdPedidos": 7
  },
  {
    "id": "H001_2026_ago_30_18:00",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "18:00",
    "qtdPedidos": 9
  },
  {
    "id": "H001_2026_ago_30_17:45",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "17:45",
    "qtdPedidos": 2
  },
  {
    "id": "H001_2026_ago_30_17:30",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "17:30",
    "qtdPedidos": 2
  },
  {
    "id": "H001_2026_ago_30_17:15",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "17:15",
    "qtdPedidos": 6
  },
  {
    "id": "H001_2026_ago_30_17:00",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "17:00",
    "qtdPedidos": 6
  },
  {
    "id": "H001_2026_ago_30_16:30",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "16:30",
    "qtdPedidos": 3
  },
  {
    "id": "H001_2026_ago_30_16:15",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "16:15",
    "qtdPedidos": 2
  },
  {
    "id": "H001_2026_ago_30_16:00",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "16:00",
    "qtdPedidos": 7
  },
  {
    "id": "H001_2026_ago_30_15:45",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "15:45",
    "qtdPedidos": 5
  },
  {
    "id": "H001_2026_ago_30_15:30",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "15:30",
    "qtdPedidos": 3
  },
  {
    "id": "H001_2026_ago_30_15:15",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "15:15",
    "qtdPedidos": 2
  },
  {
    "id": "H001_2026_ago_30_15:00",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "15:00",
    "qtdPedidos": 4
  },
  {
    "id": "H001_2026_ago_30_14:45",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "14:45",
    "qtdPedidos": 3
  },
  {
    "id": "H001_2026_ago_30_14:30",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "14:30",
    "qtdPedidos": 5
  },
  {
    "id": "H001_2026_ago_30_14:15",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "14:15",
    "qtdPedidos": 6
  },
  {
    "id": "H001_2026_ago_30_14:00",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "14:00",
    "qtdPedidos": 2
  },
  {
    "id": "H001_2026_ago_30_13:45",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "13:45",
    "qtdPedidos": 3
  },
  {
    "id": "H001_2026_ago_30_13:30",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "13:30",
    "qtdPedidos": 3
  },
  {
    "id": "H001_2026_ago_30_13:15",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "13:15",
    "qtdPedidos": 6
  },
  {
    "id": "H001_2026_ago_30_13:00",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "13:00",
    "qtdPedidos": 8
  },
  {
    "id": "H001_2026_ago_30_12:45",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "12:45",
    "qtdPedidos": 8
  },
  {
    "id": "H001_2026_ago_30_12:30",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "12:30",
    "qtdPedidos": 8
  },
  {
    "id": "H001_2026_ago_30_12:00",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "30",
    "horaVenda": "12:00",
    "qtdPedidos": 9
  },
  {
    "id": "H001_2026_ago_23_22:30",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "23",
    "horaVenda": "22:30",
    "qtdPedidos": 2
  },
  {
    "id": "H001_2026_ago_23_22:15",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "23",
    "horaVenda": "22:15",
    "qtdPedidos": 3
  },
  {
    "id": "H001_2026_ago_23_22:00",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "23",
    "horaVenda": "22:00",
    "qtdPedidos": 10
  },
  {
    "id": "H001_2026_ago_23_21:45",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "23",
    "horaVenda": "21:45",
    "qtdPedidos": 18
  },
  {
    "id": "H001_2026_ago_23_21:30",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "23",
    "horaVenda": "21:30",
    "qtdPedidos": 10
  },
  {
    "id": "H001_2026_ago_23_21:15",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "23",
    "horaVenda": "21:15",
    "qtdPedidos": 7
  },
  {
    "id": "H001_2026_ago_23_21:00",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "23",
    "horaVenda": "21:00",
    "qtdPedidos": 18
  },
  {
    "id": "H001_2026_ago_23_20:45",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "23",
    "horaVenda": "20:45",
    "qtdPedidos": 19
  },
  {
    "id": "H001_2026_ago_23_20:30",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "23",
    "horaVenda": "20:30",
    "qtdPedidos": 36
  },
  {
    "id": "H001_2026_ago_23_20:15",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "23",
    "horaVenda": "20:15",
    "qtdPedidos": 23
  },
  {
    "id": "H001_2026_ago_23_20:00",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "23",
    "horaVenda": "20:00",
    "qtdPedidos": 18
  },
  {
    "id": "H001_2026_ago_23_19:45",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "23",
    "horaVenda": "19:45",
    "qtdPedidos": 65
  },
  {
    "id": "H001_2026_ago_23_19:30",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "23",
    "horaVenda": "19:30",
    "qtdPedidos": 28
  },
  {
    "id": "H001_2026_ago_23_19:15",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "23",
    "horaVenda": "19:15",
    "qtdPedidos": 3
  },
  {
    "id": "H001_2026_ago_23_19:00",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "23",
    "horaVenda": "19:00",
    "qtdPedidos": 6
  },
  {
    "id": "H001_2026_ago_23_18:45",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "23",
    "horaVenda": "18:45",
    "qtdPedidos": 7
  },
  {
    "id": "H001_2026_ago_23_18:30",
    "codFilial": "H001",
    "nomeFilial": "H001",
    "ano": "2026",
    "diaSemana": "Domingo",
    "mes": "ago",
    "dia": "23",
    "horaVenda": "18:30",
    "qtdPedidos": 3
  }
];
